// The active-context hook now lives in the shared @kiao-voice/hooks package so
// web and desktop use one implementation. Re-exported here to keep the
// `@/lib/use-active-context` import path stable for existing consumers.
export { useActiveContext } from '@kiao-voice/hooks'
